<template>
  <rhcn-drawer
    title=""
    description=""
    :showClose="false">
    <div class="form">
      <div class="form-content">
        <div class="form-left-wrap">
          <img class="img-upgrade" src="@/assets/images/bg-upgrade.png" />
        </div>
        <div class="form-right-wrap">
          <div class="upgrade-title">{{$t('message.user.upgradeTitle')}}</div>
          <div class="upgrade-subtitle">
            <p>
              <span>{{$t('message.user.upgradeSubTitle1')}}</span>
              <!-- <span class="date">{{$t('message.user.upgradeDate')}}</span> -->
              <span>{{$t('message.user.upgradeSubTitle2')}}</span>
              <!-- <span class="date">{{$t('message.user.upgradeDate1')}}</span> -->
            </p>
            <p>{{$t('message.user.upgradeSubTitle3')}}</p>
          </div>
          <div class="upgrade-desc">
            <p>{{$t('message.user.upgradeDesc1')}}<span>{{hostInfo.old}}</span></p>
            <p>{{$t('message.user.upgradeDesc2')}}<span>{{hostInfo.new}}</span></p>
          </div>
          <el-button :loading="countTime === 0" type="primary" @click="toNewLogin">{{$t('message.user.toNewLoginUrl')}}{{countTime > 0 ? `（${countTime}）s` : ''}}</el-button>
        </div>
      </div>
    </div>
  </rhcn-drawer>
</template>
<script>
import RhcnDrawer from '@/components/drawer/index.vue';

export default {
  components: { RhcnDrawer },
  data() {
    return {
      countTime: 5,
      hostInfo: {
        old: '',
        new: '',
      },
    };
  },
  created() {
    const oldHostMap = this.$store.getters.app.oldHostMap;
    const host = window.location.host;
    this.hostInfo = {
      old: window.location.origin,
      new: oldHostMap[host],
    };
  },
  mounted() {
    this.timer = setInterval(() => {
      if (this.countTime === 0) {
        this.toNewLogin();
        return;
      }
      this.countTime -= 1;
    }, 1000);
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
  },
  methods: {
    toNewLogin() {
      clearTimeout(this.timer);
      this.timer = null;
      this.countTime = 0;
      window.location.href = this.hostInfo.new;
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/styles/unauth-right.scss';

.form {
  width: 100%;
  .form-content {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 100px;

    .form-left-wrap {
      margin-right: 20px;
      .img-upgrade {
        width: 500px;
        height: 500px;
      }
    }

    .form-right-wrap {
      max-width: 595px;
      .upgrade-title {
        font-size: 26px;
        font-weight: 600;
        color: $color-text-primary;
        line-height: 37px;
        margin-bottom: 34px;
      }

      .upgrade-subtitle {
        font-size: 20px;
        color: $color-text-primary;
        line-height: 32px;
        margin-bottom: 34px;

        .date {
          color: $color-primary;
          text-decoration: underline;
        }
      }

      .upgrade-desc {
        font-size: 16px;
        color: $color-text-primary;
        line-height: 32px;
        margin-bottom: 34px;
      }
    }
  }
}
@media screen and (max-width: 992px) {
  .form-content {
    padding: 0 20px;
  }
}
@media screen and (max-width: 1066px) {
  .form-left-wrap {
    display: none;
  }
}
</style>
